module.exports = __webpack_public_path__ + "static/media/tiny-empty-coming-soon-without-background.ca8c8a37.svg";